/**
 * Wishlist sync stub
 *
 * We now use the Cloudflare Worker ONLY for Projects Wishlist.
 * The main /pages/wishlist page continues to use the legacy
 * localStorage-based wishlist inside its own section JS.
 *
 * This stub:
 *   - Logs that it has loaded
 *   - Does NOT read or write to the Worker
 *   - Does NOT modify metafields
 *
 * That way, creating/updating Projects & Rooms will persist
 * across page visits without being wiped by this script.
 */

(function () {
  console.log('[WL] wishlist-sync.js stub loaded – Worker sync disabled for main wishlist');

  // If you ever want to add purely front-end behaviour for the main wishlist,
  // you can do it here, but DO NOT call the Worker or write metafields.
})();
